import { getEnabledElementsByImageId } from './enabledElements.js';
import drawImage from './internal/drawImage.js';

/**
 * Forces the image to be updated/redrawn for all enabled elements
 * displaying the specified imageId
 *
 * @param {string} imageId The imageId of the Cornerstone Image Object to redraw
 * @returns {void}
 * @memberof Drawing
 */
function invalidateImageId(imageId) {
  const enabledElements = getEnabledElementsByImageId(imageId);

  for (const enabledElement of enabledElements) {
    drawImage(enabledElement, true);
  }
}

export default invalidateImageId;
